function initColumnSliders() {
  document.querySelectorAll('.col-slider').forEach(function (slider) {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';

    var track = slider.querySelector('.col-slider__track');
    var slides = slider.querySelectorAll('.col-slider__slide');
    var prevBtn = slider.querySelector('.col-slider__prev');
    var nextBtn = slider.querySelector('.col-slider__next');
    var dotsWrap = slider.querySelector('.col-slider__dots');
    var index = 0;
    var total = slides.length;

    if (total <= 1) {
      slider.setAttribute('data-single', 'true');
      return;
    }

    // Crear puntos indicadores
    var dots = [];
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'col-slider__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Ir a foto ' + (i + 1));
      (function (idx) {
        dot.addEventListener('click', function () {
          goTo(idx);
        });
      })(i);
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }

    function update() {
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    function goTo(i) {
      index = (i + total) % total;
      update();
    }

    prevBtn.addEventListener('click', function () { goTo(index - 1); });
    nextBtn.addEventListener('click', function () { goTo(index + 1); });

    // Autoplay opcional (configurado desde el editor de temas)
    if (slider.dataset.autoplay === 'true') {
      var speed = parseInt(slider.dataset.speed, 10) || 4000;
      setInterval(function () { goTo(index + 1); }, speed);
    }

    update();
  });
}

document.addEventListener('DOMContentLoaded', initColumnSliders);
// Reinicializa si se agrega/edita la sección desde el editor de temas
document.addEventListener('shopify:section:load', initColumnSliders);